import React, { Component } from "react";
import {Spinner} from 'react-bootstrap';

import CampaignItem from './CampaignItem';

class CampaignTable extends Component {

  renderTableHeaders(){
    return (
      <thead>
        <tr>
          <th>Name</th>
          <th>Created</th>
          <th>Type</th>
          <th>Author</th>
          <th>Status</th>
        </tr>
      </thead>
    )
  }

  renderEmptyTable(isLoading){
      let loadingContent = <td colSpan="5"><i className="bi bi-exclamation-triangle"></i> No data found</td>;
      if (isLoading){
        loadingContent = <td colSpan="5"><Spinner animation="border" size="sm" /></td>;
      }

    return (
      <div className="table-responsive">
        <table className="table table-striped table-hover">
            {this.renderTableHeaders()}
            <tbody>
            <tr>
              {loadingContent}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderTable(){
    return (
      <div className="table-responsive">
        <table className="table table-striped table-hover" data-tid="campaign-table">
            {this.renderTableHeaders()}
            <tbody>
              {
                this.props.content && this.props.content.map((campaign, index) => (
                    <CampaignItem campaign={campaign} key={index}/>
                )) 
              }
            </tbody>
        </table>
      </div>
    )
  }

  render(){ 
    if (this.props.content === null){
      return this.renderEmptyTable(true);

    }else if (this.props.content.length === 0){
      return this.renderEmptyTable(false);

    }else{
      return this.renderTable();
    }
  }
}

export default CampaignTable;
